import {
  dispatchApprovalFieldNavigate,
  getFieldDomPathCandidates,
} from "./fieldDomUtils";

export const findFieldElementByPath = (path) => {
  if (!path) {
    return null;
  }

  const candidates = getFieldDomPathCandidates(path);

  for (const candidate of candidates) {
    const selectors = [
      () => document.getElementById(candidate),
      () => document.querySelector(`[name="${candidate}"]`),
      () => document.querySelector(`[data-field="${candidate}"]`),
    ];

    for (const selector of selectors) {
      const element = selector();

      if (element) {
        return element;
      }
    }
  }

  return null;
};

/**
 * Attempts to focus on a form field by its path.
 * Uses the same strategy as useFocusErrorForm.
 */
const focusFieldByPath = (path, maxAttempts = 2, onFound) => {
  if (!path) {
    return;
  }

  let attempts = 0;

  dispatchApprovalFieldNavigate(path);

  const scrollToElement = (element) => {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    setTimeout(() => {
      if (typeof element.focus === "function") {
        element.focus();
      }
    }, 300);

    onFound?.(element);
  };

  const findAndScrollToElement = () => {
    attempts++;

    const element = findFieldElementByPath(path);

    if (!element && attempts < maxAttempts) {
      setTimeout(findAndScrollToElement, 100);
      return;
    }

    if (element) {
      scrollToElement(element);
    }
  };

  setTimeout(findAndScrollToElement, 150);
};

export default focusFieldByPath;
